/* global axios */
import ApiClient from './ApiClient';

class CmsPagesAPI extends ApiClient {
  constructor() {
    super('cms_pages', { accountScoped: true });
  }

  publish(id) {
    return axios.post(`${this.url}/${id}/publish`);
  }

  unpublish(id) {
    return axios.post(`${this.url}/${id}/unpublish`);
  }
}

export default new CmsPagesAPI();
